import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import moment from 'moment';
import props from "prop-types";
import { Grid, Table, Pagination, Segment, Input, Button, Icon, Form, Modal } from 'semantic-ui-react';
import { updateCustomer, getCustomers, getCustomerById, sortCustomers, setActivePage, showLoading, hideLoading, openCustomerModal, exportCustomers, getCustomersReport, exportCreditReport, getCreditReport } from '../actions';
import CustomerDetails from './CustomerDetails';
import download_icon from '../assets/img/download_xlsx.png';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


class Customers extends Component {
    state = {
        date: new Date(),
        column: null,
        data: [],
        length: 0,
        direction: null,
        page: 0,
        rowsPerPage: 18,
        addCustomerModal: false,
        newCustomer: {
            name: '',
            email: '',
            phone: '',
            mobile: '',
            address: {
                address_1: '',
                address_2: '',
                postcode: '',
                town_city: '',
                state: '',
                country: ''
            }
        },
        searchValue: ''
    }


    constructor(props) {
        super(props);
        window.Handlebars.registerHelper('currency', function (value) {
            return value.toFixed(2);
        });
        window.Handlebars.registerHelper('date', function (date) {
            return moment(date).format('DD/MM/YYYY');
        });
        window.Handlebars.registerHelper('math', function (lvalue, operator, rvalue, options) {
            lvalue = parseFloat(lvalue);
            rvalue = parseFloat(rvalue);

            return {
                "+": lvalue + rvalue,
                "-": lvalue - rvalue,
                "*": lvalue * rvalue,
                "/": lvalue / rvalue,
                "%": lvalue % rvalue
            }[operator];
        });
        window.Handlebars.registerHelper('ifDiffEq', function (a, b, c, options) {
            if ((a - b) === c) {
                return options.fn(this);
            } else {
                return options.inverse(this);
            }
        });
        window.Handlebars.registerHelper('index', function (rows, pages, items) {
            return (parseInt(rows) * parseInt(pages)) + parseInt(items) + 1;
        });
        props.showLoading('Retrieving Customer List . . . ');
        props.getCustomers({});

        let now = new Date();
        this.year = now.getFullYear();
        this.month = now.getMonth();
        this.yearOptions = _.range(this.year, this.year - 10, -1).map(year => { return { key: year, text: year, value: year } });
    }

    componentDidMount() {
        this.props.setActivePage('customers');
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.customer.list !== nextProps.customer.list) {
            console.log(nextProps.customer.list);
            this.setState({ data: _.chunk(nextProps.customer.list, this.state.rowsPerPage), length: nextProps.customer.list.length, column: nextProps.customer.sortColumn, direction: nextProps.customer.sortDirection, page: 0 });
            this.props.hideLoading();
        } else if ((this.props.customer.sortColumn !== nextProps.customer.sortColumn) || (this.props.customer.sortDirection !== nextProps.customer.sortDirection)) {
            this.setState({ data: _.chunk(nextProps.customer.list, this.state.rowsPerPage), column: nextProps.customer.sortColumn, direction: nextProps.customer.sortDirection, page: 0 });
        } else if (nextProps.customer.creditReport && (this.props.customer.creditReport !== nextProps.customer.creditReport)) {
            let pages = _.chunk(nextProps.customer.creditReport.docs, this.state.rowsPerPage);
            let data = {
                stmt_date: this.state.date,
                num_pages: pages.length,
                rowsPerPage: this.state.rowsPerPage,
                pages: pages,
                summary: nextProps.customer.creditReport.summary
            };
            let html = window.Handlebars.templates.creditreport(data);
            let strWindowFeatures = "menubar=yes,location=no,resizable=no,scrollbars=yes,status=no";
            // window.open(window.location.hostname + ':' + window.location.port + html, "_blank", strWindowFeatures);
            let stmt_wnd = window.open("", "_blank");
            stmt_wnd.document.write(html);
        }
    }

    handleChangeDate(date) {
        this.setState({
            date: date
        });
    }

    handleSort = (clickedColumn) => () => {
        this.props.sortCustomers(clickedColumn);
    }

    handleCustomerSelect = (id, e) => {
        // e.preventDefault();
        this.props.getCustomerById(id);
    }

    handleSearchChange = (e) => {
        var sValue = e.target.value;
        this.setState({ searchValue: sValue });
    }

    handleSearchSubmit = (e) => {
        if (e.keyCode !== 13) {
            return;
        }

        const re = new RegExp(_.escapeRegExp(e.target.value), 'i')
        const isMatch = result => (re.test(result.name) | re.test(result.email));

        let customer_list = _.filter(this.props.customer.list, isMatch);
        this.setState({ data: _.chunk(customer_list, this.state.rowsPerPage), length: customer_list.length });
    }

    handleRefresh = () => {
        this.props.showLoading('Retrieving Customer List . . . ');
        this.props.getCustomers({});
        console.log("Refresh List");
    }

    handleGenerateReport() {
        this.props.exportCustomers(false);
        this.props.showLoading('Generating customers report . . .');
        this.props.getCustomersReport({});
    }

    closeModal() {
        this.props.exportCustomers(false);
    }

    handleExportCreditReport() {
        this.props.exportCreditReport(false);
        // this.props.showLoading('Generating credit report . . .');
        this.props.getCreditReport(this.state.date);
    }


    closeCreditReportModal() {
        this.props.exportCreditReport(false);
    }

    render() {
        const { data, page, column, direction, rowsPerPage, length, searchValue, date } = this.state;
        const { exportModal, creditReportModal } = this.props.customer;

        return (
            <Fragment>
                <Modal open={creditReportModal} onClose={this.closeCreditReportModal.bind(this)}>
                    <Modal.Header>
                        Export Credit Report &nbsp; <Icon name='sticky note outline' />
                    </Modal.Header>
                    <Modal.Content>
                        <Table style={{ border: '0px' }}>
                            <Table.Row>
                                <Table.Cell>
                                   <b> Date </b>
                                        <DatePicker
                                        dateFormat="dd/MM/yyyy"
                                        selected={this.state.date}
                                        selectsStart
                                        startDate={this.state.date}
                                        onChange={this.handleChangeDate.bind(this)}
                                        isClearable={false}
                                        todayButton={"Today"}
                                        showMonthDropdown
                                        customInput={<DatePickerInput value={props.value} onClick={props.onClick} />}
                                    />
                                </Table.Cell>
                            </Table.Row>
                        </Table>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={this.closeCreditReportModal.bind(this)}>Close</Button>
                        <Button color='primary' onClick={this.handleExportCreditReport.bind(this)}>Export</Button>
                    </Modal.Actions>
                </Modal>
                <Modal open={exportModal} onClose={this.closeModal.bind(this)}>
                    <Modal.Header>
                        Export Customer Report
                    </Modal.Header>
                    <Modal.Content>
                        <p><b><img src={download_icon} style={{ verticalAlign: 'middle' }} height={80} width='auto' /> Customer_List.xlsx</b></p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={this.closeModal.bind(this)}>Close</Button>
                        <Button color='primary' onClick={this.handleGenerateReport.bind(this)}>Download</Button>
                    </Modal.Actions>
                </Modal>
                <CustomerDetails />
                <Grid>
                    <Grid.Column floated='left' width={14}>
                        <Input icon='search' placeholder='Search...' value={searchValue} onKeyUp={this.handleSearchSubmit} onChange={this.handleSearchChange} />
                    </Grid.Column>
                    <Grid.Column floated='right' width={1}>
                        <Button icon onClick={this.handleRefresh}><Icon name='refresh' /></Button>
                    </Grid.Column>
                </Grid>
                <Table sortable celled structured selectable>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>
                            </Table.HeaderCell>
                            <Table.HeaderCell sorted={column === 'name' ? direction : null} onClick={this.handleSort('name')}>
                                Name
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Company
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Mobile
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Email
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Address
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Balance
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {data[page] &&
                            (data.length > 0) ?
                            data[page].map((customer, index) => {
                                return (
                                    <Table.Row key={index} onClick={this.handleCustomerSelect.bind(this, customer._id)}>
                                        <Table.Cell>{length - (page * rowsPerPage + index)}</Table.Cell>
                                        <Table.Cell>{customer.name}</Table.Cell>
                                        <Table.Cell>{customer.company}</Table.Cell>
                                        <Table.Cell><a href={'tel:' + customer.mobile} onClick={(e) => e.stopPropagation()}>{customer.mobile}</a></Table.Cell>
                                        <Table.Cell><a href={'mailto:' + customer.email} onClick={(e) => e.stopPropagation()}>{customer.email}</a></Table.Cell>
                                        <Table.Cell>{customer.address.address_1}, {customer.address.address_2}, {customer.address.postcode} {customer.address.town_city}, {customer.address.state}, {customer.address.country}</Table.Cell>
                                        <Table.Cell>RM {(customer.balance) ? (customer.balance.value).toFixed(2) : Number(0).toFixed(2)}</Table.Cell>
                                    </Table.Row>)
                            }) :
                            <Table.Row>
                                <Table.Cell colSpan="7" textAlign="center">
                                    No Record Found
                                 </Table.Cell>
                            </Table.Row>
                        }
                    </Table.Body>
                </Table>
                <Pagination style={{ float: 'right' }} activePage={page + 1} totalPages={Math.ceil(length / rowsPerPage)} onPageChange={(e, data) => this.setState({ page: data.activePage - 1 })} />
            </Fragment>
        )
    }
}

const DatePickerInput = ({ value, onClick }) => (
    <Input
        name="requestedDate"
        value={value}
        placeholder="Date"
        onClick={onClick}
        // classNameName="calendar-input"
        style={{ margin: '5px', cursor: 'pointer' }}
        autoComplete="false"
        readOnly={true}
    />
);

const mapStateToProps = ({ customer }) => {
    return { customer }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        updateCustomer: updateCustomer,
        getCustomers: getCustomers,
        getCustomerById: getCustomerById,
        sortCustomers: sortCustomers,
        setActivePage: setActivePage,
        showLoading: showLoading,
        hideLoading: hideLoading,
        openCustomerModal: openCustomerModal,
        exportCustomers: exportCustomers,
        getCustomersReport: getCustomersReport,
        exportCreditReport: exportCreditReport,
        getCreditReport: getCreditReport,
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Customers);